// extracted by mini-css-extract-plugin
export var circle = "magic-link-module--circle--E5FXM";
export var container = "magic-link-module--container--Tv1Mr";
export var iconWrapper = "magic-link-module--icon-wrapper--s3NHz";
export var linkWrapper = "magic-link-module--link-wrapper--Gt4HO";
export var text = "magic-link-module--text--95E7F type--text-m---eRFt type--font-futura--HOUH4";